import { render, staticRenderFns } from "./campaignTopCities.vue?vue&type=template&id=1c72e0d2&"
import script from "./campaignTopCities.vue?vue&type=script&lang=js&"
export * from "./campaignTopCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports